import {useCustomerResponse} from '@aboutyou/user';
import {useShowCampaignPhonePopup} from '../../../backend-services/Campaigns/hooks/useShowCampaignPhonePopup';
import {useIsAppWelcomeCouponBannerEnabled} from '../../Coupons/useIsAppWelcomeCouponBannerEnabled';
import {useIsCouponsEnabled} from '../../Coupons/useIsCouponsEnabled';
import {useIsWebCouponsEnabled} from '../../Coupons/useIsWebCouponsEnabled';

export const useIsGenericWebCouponBannerEnabled = () => {
  // TODO: remove this during the cleanup phase https://aboutyou.atlassian.net/browse/ASFE-10356
  const isWebCouponsActive = useIsWebCouponsEnabled();
  const isCouponsActive = useIsCouponsEnabled();
  const isAppWelcomeCouponBannerEnabled = useIsAppWelcomeCouponBannerEnabled();
  const showCampaignPhonePopup = useShowCampaignPhonePopup();
  const customerResponse = useCustomerResponse();

  return (
    isAppWelcomeCouponBannerEnabled &&
    (isWebCouponsActive || isCouponsActive) &&
    !showCampaignPhonePopup &&
    customerResponse.data &&
    customerResponse.data.showAppInstallBanner
  );
};
